<template>
    <div class="detalhes-fluxo">
        <b-modal
            ref="modalDetalheDREInfo"
            id="modal-detalhe-dre-info"
            size="xl"
            no-close-on-esc
            no-close-on-backdrop
            :title="`Detalhes de Linha - ${ planoDeContaTemp.descricao }`"
            tabindex="-1"
            >
            <el-table
                class="p-table"
                v-loading="loadingDetalhe"
                :data="detalhesModal.detalhes || []"
                style="width: 100%"
                height="350"
                stripe
                border
                size="mini">

                <el-table-column
                    prop="data"
                    label="Data"
                    width="100"
                    align="center">
                </el-table-column>

                <el-table-column
                    prop="empresa"
                    show-overflow-tooltip
                    label="Empresa"
                    align="left">
                    <template slot="header" slot-scope="scope">
                        Empresa
                        <el-popover
                        placement="bottom"
                        trigger="click"
                        v-model="filterIsVisible"
                        width="400">
                            <div>
                                <el-select
                                    v-model="empresaId"
                                    filterable
                                    clearable
                                    :placeholder="`Selecione uma empresa`"
                                    style="width:100%; display:block; margin-bottom: 7px;"
                                    size="small"
                                >
                                    <el-option
                                        v-for="item in detalhesModal.empresas"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <el-button style="float:right" type="primary" size="mini" icon="el-icon-search" @click="setFilter">Filtrar</el-button>
                            <el-button style="float:right; margin-right: 5px;" size="mini" icon="el-icon-brush" @click="clearFilter">Limpar</el-button>
                            <el-button style="float:right" slot="reference" icon="fas fa-filter" size="mini" circle></el-button>
                        </el-popover>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="origem"
                    label="Origem do franqueado"
                    width="170"
                    align="left">
                </el-table-column>

                <el-table-column
                    prop="meioDePagamento"
                    label="Observação"
                    width="170"
                    align="left">
                </el-table-column>

                <el-table-column
                    prop="fornecedor"
                    show-overflow-tooltip
                    label="Fornecedor"
                    align="left">
                </el-table-column>

                <el-table-column
                    prop="historico"
                    show-overflow-tooltip
                    label="Historico"
                    align="left">
                </el-table-column>

                <el-table-column
                    prop="valor"
                    label="Valor"
                    width="150"
                    align="right">
                </el-table-column>
                
            </el-table>
            <template #modal-footer="{ hide }">
                <div class="left-btn">
                    <el-button size="small" type="success" icon="el-icon-download" @click="exportarDetalhes" :loading="loadingExportar">Exportar</el-button>
                </div>
                <div class="float-right">
                    <el-button size="small" @click="hide()">Fechar</el-button>
                </div>
			</template>
            <br>

            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="pagination.pageSize"
                :current-page.sync="pagination.page"
                layout="sizes, prev, pager, next"
                background
                class="text-center"
                :total="pagination.total"
                >
            </el-pagination>
        </b-modal>
        <el-collapse v-if="premiumUser()" v-model="activeNamesCollapse">
            <el-collapse-item v-if="dataModal.detalhes" :name="i" v-bind:key="i" v-for="(detalhe,i) in dataModal.detalhes" class="det-list-item">
                <template slot="title">
                    <el-row :gutter="10" class="det-header">
                        <el-col :span="20">
                            {{ detalhe.nome }}
                        </el-col>
                        <el-col :span="4" :class="formatClassColor(detalhe)">
                            {{ toMoney(detalhe) }}
                        </el-col>
                    </el-row>
                </template>
                <div>
                    <el-table
                        class="p-table"
                        :data="detalhe.values || []"
                        style="width: 100%"
                        stripe
                        border
                        size="mini">

                        <el-table-column
                            prop="nome"
                            label="Nome"
                            align="left">
                        </el-table-column>
                        
                        <el-table-column
                            label="Valor"
                            align="center"
                            width="100">
                            <template slot-scope="scope" v-if="scope.row">
                                <span :class="formatClassColor(scope.row)">
                                    {{ toMoney(scope.row) }}
                                </span>
                            </template>
                        </el-table-column>
                        
                        <el-table-column
                            label="Ação"
                            width="170"
                            align="center">
                            <template slot-scope="scope" v-if="scope.row">
                                <el-button round icon="el-icon-view" size="mini" @click="callDetalhe(scope.row)">Detalhes</el-button>
                            </template>
                        </el-table-column>
                        
                    </el-table>
                </div>
            </el-collapse-item>
            <div v-if="!dataModal.detalhes" class="det-list-item">
                <el-table
                    class="p-table"
                    :data="datas.detalhes || []"
                    style="width: 100%"
                    stripe
                    show-summary
                    :summary-method="setTotal"
                    border
                    size="mini">

                    <el-table-column
                        prop="descricao"
                        label="Nome"
                        align="left">
                    </el-table-column>
                    
                    <el-table-column
                        prop="valores"
                        label="Valor"
                        align="center"
                        width="100">
                        <template slot-scope="scope" v-if="scope.row">
                            <span :class="formatClassColor(scope.row)">
                                {{ toMoney(scope.row) }}
                            </span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column
                        label="Ação"
                        width="170"
                        align="center">
                        <template slot-scope="scope" v-if="scope.row">
                            <el-button round icon="el-icon-view" size="mini" :loading="loadingDetalhe" @click="callDetalhe(scope.row)">Detalhes</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-collapse>
        <div v-else>
            <el-alert
                title="Não possui acesso"
                description="Detalhe de DRE está disponível apenas para usuários premium."
                type="info">
            </el-alert>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'detalhe-fluxo-caixa',
        props: {
            datas: { type: Object },
            source: { type: Array },
        },
        data() {
            return {
                dataModal: {},
                activeNamesCollapse: [0,1],
                filterIsVisible: false,
                loadingExportar: false,
                loadingDetalhe: false,
                detalhesModal: {},
                planoDeContaTemp: {},
                empresaId: '',
                pagination: {
                    page: 1,
                    pageSize: 25,
                    total: 0
                }
            }
        },
        computed: {
            dreFiltros: {
                get() {
                    return this.$store.state.dreFiltros;
                },
                set(value) {
                    this.$store.commit('updateDREFiltros', value);
                }
            }
        },
        methods: {
            toMoney(num){ // FORMATA REAL
                if(!num) {
                    return ''
                }
                let n = num.valor ? num.valor : 0;
                return n ? Number(n).toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' }) : 'R$ 0,00'
            },
            formatClassColor(num){
                let n = num.valor ? num.valor : 0;
                return n >= 0 ? 'positive' : 'negative';
            },
            setTotal() {
                return ['Valor total',this.toMoney(this.datas.total)]
            },
            handleSizeChange(val) {
                this.pagination.pageSize = val
                this.pagination.page = 1
                this.getDetalhe(this.planoDeContaTemp)
            },
            handleCurrentChange(val) {
                this.pagination.page = val
                this.getDetalhe(this.planoDeContaTemp)
            },
            setFilter() {
                this.pagination.page = 1
                this.getDetalhe(this.planoDeContaTemp)
            },
            clearFilter() {
                this.empresaId = ''
                this.getDetalhe(this.planoDeContaTemp)
            },
            pegarDetalhesDeLinhasDaDRE(linhaId, descricao) {
                var result = null;
                const dt = this.source

                dt.forEach((value) =>{
                    if (result != null)
                        return;

                    if (value.linhaDaDREId == linhaId){
                        result = value.meses.find(t => t.descricao == descricao);
                        return;
                    }

                    result = this.pegarDosFilhos(value, linhaId, descricao);
                });

                return result;
            },
            pegarDosFilhos(value, linhaId, descricao){
                var result = null;
                
                if (value.filhos == null || value.filhos == undefined || value.filhos.length == 0){
                    return result;
                }

                value.filhos.forEach((filho)=>{
                    if (result != null){
                        return;
                    }

                    if (filho.linhaDaDREId == linhaId){
                        result = filho.meses.find(t => t.descricao == descricao);
                        return;
                    }
                    
                    result = this.pegarDosFilhos(filho, linhaId, descricao)
                })

                return result;
            },
            callDetalhe(model) {
                if (model.linhaDaDREId != null) {
                  this.dataModal = this.pegarDetalhesDeLinhasDaDRE(model.linhaDaDREId, model.descricao)
                }else {
                  this.getDetalhe(model)
                }
            },
            handleError(title, message) {
              this.$notify.error({
                title,
                message,
                position: 'top-left'
              });
            },
            async getDetalhe(model) {
                this.planoDeContaTemp = model;
                this.loadingDetalhe = true;

                try {
                    const { data, status } = await this.axios.post(this.$urls.DRE_DETALHES_LINHA_DRE, {
                      PlanoDeContasId: this.planoDeContaTemp.planoDeContasId,
                      tipoDeValorDePDV: this.planoDeContaTemp.tipoDeValorDePDV,
                      cmv: this.planoDeContaTemp.cmv,
                      linhaId: this.planoDeContaTemp.linhaId,
                      competencia: this.planoDeContaTemp.descricao,
                      linhaManualDaDREId: this.planoDeContaTemp.linhaManualDaDREId,
                      Page: this.pagination.page,
                      PageSize: this.pagination.pageSize,
                      empresaId: this.empresaId,
                      filter: this.dreFiltros
                    },{ suppressInterceptorError: true });

                    if (status !== 200) {
                      this.handleError('Detalhes indisponíveis', data);
                      return;
                    }

                    // exibe o modal e atualiza os detalhes
                    this.$bvModal.show('modal-detalhe-dre-info');
                    this.detalhesModal = data;
                    this.pagination.total = data.total;

                } catch (err) {
                    if (err.response) {
                      this.handleError('Detalhes indisponíveis', err.response.data || 'Não foi possível carregar os detalhes');
                      return;
                    }

                    // Erro genérico caso não tenha resposta
                    this.handleError('Erro interno', 'Algum erro interno ocorreu, por favor entre em contato com o suporte');
                } finally {
                    this.loadingDetalhe = false;
                    this.filterIsVisible = false;
                }
            },
            async exportarDetalhes() { 
                try {
                    this.loadingExportar = true
                    const response = await this.axios.post(this.$urls.DRE_EXPORTAR_DETALHES_LINHA, {
                        PlanoDeContasId: this.planoDeContaTemp.planoDeContasId,
                        tipoDeValorDePDV: this.planoDeContaTemp.tipoDeValorDePDV,
                        cmv: this.planoDeContaTemp.cmv,
                        linhaId: this.planoDeContaTemp.linhaId,
                        competencia: this.planoDeContaTemp.descricao,
                        linhaManualDaDREId: this.planoDeContaTemp.linhaManualDaDREId,
                        Page: this.pagination.page,
                        PageSize: this.pagination.pageSize,
                        empresaId: this.empresaId,
                        filter: this.dreFiltros
                    });

                    if(response.status !== 200) {
                        this.$notify.error({
                            title: 'Exportar detalhe',
                            message: `Não foi possível Exportar detalhes para ${this.planoDeContaTemp.nome}`,
                            position:'top-left'
                        });
                        return
                    }
                    this.$notify({
                        type: "success",
                        title: 'Gerando Relatório',
                        dangerouslyUseHTMLString: true,
                        message: `Sua solicitação de relatório foi enviada, por favor verifique a tela de <a href="/#/relatorio" target="_blank">relatórios</a>`
                    });

                } catch(err) {
                    this.$notify.error({
                            title: 'Erro interno',
                            message: `Algum erro interno ocorreu, por favor entre em contato com o suport`,
                            position:'top-left'
                        });
                } finally {
                    this.loadingExportar = false
                }
            }
        },
        mounted() {
            this.dataModal = this.datas
        }
    }
</script>

<style lang="scss" scoped>
    .det-list-item {
        .positive {
            color:#28a745 !important;
        }
        .negative {
            color:#dc3545 !important;
        }
    }
    .det-header {
        width:100%;
    }
    .left-btn {
        position: absolute; 
        left: 15px;
    }
</style>
<style lang="scss">
    .detalhes-fluxo {
        .el-collapse-item__content {
            background: #f7f7f7;
            padding: 10px;
        }
        .el-table__footer-wrapper {
            font-weight: 900;
        }
    }
    .p-table {
        tr.el-table__row td.el-table__cell {
            background: #fff;
        }
        tr.el-table__row:hover td.el-table__cell {
            background: #f5faff !important;
        }
    }
</style>
